export default "/packs/images/logo~84f5dceda231c20c5f74d9029584b686.png";